import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { CheckSquare, Calendar, AlertCircle } from "lucide-react";

interface ReviewActionsTabProps {
  data: any;
}

export function ReviewActionsTab({ data }: ReviewActionsTabProps) {
  if (!data.action_items || data.action_items.length === 0) {
    return (
      <Card className="p-12 text-center">
        <CheckSquare className="h-12 w-12 mx-auto mb-3 text-muted-foreground/50" />
        <p className="text-muted-foreground">No action items recorded</p>
      </Card>
    );
  }

  const getPriorityColor = (priority: string) => {
    switch (priority) {
      case "high": return "destructive";
      case "medium": return "secondary";
      case "low": return "outline";
      default: return "outline";
    }
  };

  return (
    <div className="space-y-4">
      {data.action_items.map((item: any, index: number) => (
        <Card key={index} className="p-6">
          <div className="flex items-start gap-3">
            <AlertCircle className={`h-5 w-5 flex-shrink-0 mt-0.5 ${
              item.priority === "high" ? "text-red-600" :
              item.priority === "medium" ? "text-yellow-600" :
              "text-blue-600"
            }`} />
            
            <div className="flex-1 space-y-3">
              <div>
                <p className="font-medium">{item.description}</p>
                <div className="flex flex-wrap gap-2 mt-2">
                  <Badge variant={getPriorityColor(item.priority)}>
                    {item.priority.charAt(0).toUpperCase() + item.priority.slice(1)} Priority
                  </Badge>
                  {item.status && (
                    <Badge variant="outline">{item.status}</Badge>
                  )}
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-3 text-sm">
                {item.assigned_to_name && (
                  <div>
                    <span className="text-muted-foreground">Assigned to: </span>
                    <span className="font-medium">{item.assigned_to_name}</span>
                  </div>
                )}
                {item.due_date && (
                  <div className="flex items-center gap-1">
                    <Calendar className="h-3 w-3 text-muted-foreground" />
                    <span className="text-muted-foreground">Due: </span>
                    <span className="font-medium">
                      {new Date(item.due_date).toLocaleDateString()}
                    </span>
                  </div>
                )}
              </div>

              {item.notes && (
                <p className="text-sm text-muted-foreground">{item.notes}</p>
              )}
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
}
